import React, { forwardRef } from "react";

const Checkbox = forwardRef(
  (
    {
      id,
      name,
      checked,
      onChange,
      label,
      className = "",
      labelClass = "",
      items = "",
      marginTop = "",
      disabled = false,
      required,
    },
    ref
  ) => (
    <div className={`flex ${items || "items-start"} space-x-2 ${className}`}>
      {/* Checkbox box */}
      <label
        htmlFor={id || name}
        className="relative cursor-pointer mt-[2px]" // ✅ Align top
      >
        <input
          type="checkbox"
          id={id || name}
          name={name}
          checked={!!checked}
          onChange={onChange}
          disabled={disabled}
          ref={ref}
          className="peer hidden"
        />
        <div
          className={`w-4 h-4 border-2 rounded-sm flex items-center justify-center ${marginTop}
          transition-all duration-300 ease-in-out
          ${
            checked
              ? "border-green-600 bg-green-100 scale-110"
              : "border-gray-400 bg-white"
          }`}
        >
          <svg
            viewBox="0 0 24 24"
            className="w-4 h-4 text-green-600"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline
              points="4 12 9 17 20 6"
              style={{
                strokeDasharray: 22,
                strokeDashoffset: checked ? 0 : 22,
                opacity: checked ? 1 : 0,
                transition: "stroke-dashoffset 0.6s ease-in-out, opacity 0.3s",
              }}
            />
          </svg>
        </div>
      </label>

      {/* Label text */}
      {label && (
        <label
          htmlFor={id || name}
          className={`text-sm cursor-pointer leading-snug ${labelClass}`} // ✅ leading-snug improves vertical spacing
        >
          {label}
          {required && <span className="text-red-500 pl-1">*</span>}
        </label>
      )}
    </div>
  )
);

export default Checkbox;
